import Vue from 'vue'
import Router from 'vue-router'
import AdminRoutes from './admin'

Vue.use(Router)

export default new Router({
  routes: [
    AdminRoutes
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js